// Keeps the topbar neutral while the cleared getUser refetches as null, instead of flashing the anonymous CTA.
// endLogout() runs when the bare /login page mounts, or the flag survives into the next session (login is a client nav too).
import { useSyncExternalStore } from 'react'

let loggingOut = false
const listeners = new Set<() => void>()

export function beginLogout() {
  if (loggingOut) return
  loggingOut = true
  for (const fn of listeners) fn()
}

export function endLogout() {
  if (!loggingOut) return
  loggingOut = false
  for (const fn of listeners) fn()
}

function subscribe(fn: () => void) {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}

export function useIsLoggingOut() {
  return useSyncExternalStore(
    subscribe,
    () => loggingOut,
    () => false,
  )
}
